exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delivery-quotation-letter[data-v-08c4d375]{line-height:16px}.delivery-quotation-letter p[data-v-08c4d375]{margin-bottom:12px}.delivery-quotation-letter b[data-v-08c4d375],.delivery-quotation-letter strong[data-v-08c4d375]{text-transform:none}.delivery-quotation-letter ul[data-v-08c4d375]{list-style:disc;margin-left:25px}", ""]);

// exports
